import { render, staticRenderFns } from "./AiJobs.vue?vue&type=template&id=cbead60c&scoped=true&"
import script from "./AiJobs.vue?vue&type=script&lang=js&"
export * from "./AiJobs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbead60c",
  null
  
)

export default component.exports